import type { IGameRoundsView } from '@hit-game/shared/types';

import { useServerEvent } from './useServerEvent';

/** Ảnh chụp hũ đẩy realtime (mỗi lần observer refresh). */
export interface JackpotStateEvent {
  type: 'state';
  status: 'connecting' | 'connected' | 'disconnected';
  updatedAt: string;
  games: { gid: number; name?: string; jackpot: number }[];
}

/** Một hũ vừa NỔ. */
export interface JackpotWinEvent {
  type: 'win';
  gid: number;
  name?: string;
  value: number;
  at: number;
}

/**
 * Gói VÁN của 4 game — cùng channel với hũ, KHÔNG phải một stream riêng.
 *
 * Phải có mặt trong union: observer đẩy loại này mỗi lần nó ghi `game:rounds`
 * (tới 2 lần/giây suốt chuyến bay Máy bay). Union chỉ khai hai nhánh thì consumer
 * nào phân loại bằng `if (state) … else` sẽ nuốt nhầm nó vào nhánh `win` — mà
 * TypeScript không cản được, vì chỗ parse là một phép ép kiểu mù.
 */
export interface JackpotRoundsEvent extends IGameRoundsView {
  type: 'rounds';
}

export type JackpotEvent = JackpotStateEvent | JackpotWinEvent | JackpotRoundsEvent;

/**
 * Nghe SSE `event: jackpot` (broadcast toàn cục — server KHÔNG lọc userId cho
 * jackpot) qua connection dùng chung {@link useServerEvent}.
 *
 * Channel này chở BA loại frame (`state`, `win`, `rounds`). Mọi consumer phải
 * phân loại TƯỜNG MINH theo `type` và bỏ qua loại nó không quan tâm — nhánh
 * `else` bắt tất là bug chờ sẵn cho lần thêm loại thứ tư.
 */
export function useJackpotEvents(onEvent: (event: JackpotEvent) => void, enabled = true): void {
  useServerEvent(
    'jackpot',
    (data) => {
      try {
        onEvent(JSON.parse(data) as JackpotEvent);
      } catch {
        // Bỏ qua frame hỏng định dạng.
      }
    },
    enabled,
  );
}
